import * as React from "react"
import { useLocation } from "@reach/router"
import { useState } from "react"
import { Link, Script, ScriptStrategy } from "gatsby"

export interface MetaDirectivesProps {
  belongsToPageName: string
  ogDescription: string
  ogImage?: { file: { url: string } }
  ogTitle: string
  robots: string[]
  metaPropertyOgtype: string
  metaPropertyoglocale: string[]
  twittertitle: string
  twitterTwitterdescription: string
  twitterTwitterimage?: { file: { url: string } }
  favicoIco?: { file: { url: string } }
  node_locale: string
  canonical: string[]
}

export const MetaDirectives = (props: any): JSX.Element => {
  let schemaOrgMarkup = props.schemaOrg
  let schemaOrg
  let schemaOrgJson
  let schemaOrgText =
  props.schemaOrgText !== undefined ? props.schemaOrgText : null

  schemaOrgMarkup?._type !== "FAQPage" &&
  schemaOrgMarkup !== null &&
  schemaOrgMarkup !== undefined
    ? (schemaOrgJson = (
        <script type="application/ld+json">
          {`{
            "@context": "${schemaOrgMarkup._context}",
            "@type": "${schemaOrgMarkup._type}",
            "name": "${schemaOrgMarkup.name}",
            "url": "${schemaOrgMarkup.url}",
            "logo": "${schemaOrgMarkup.logo}",
            "contactPoint": [
              {
              "@type": "${schemaOrgMarkup.contactPoint[0]._type}",
              "telephone": "${schemaOrgMarkup.contactPoint[0].telephone}",
              "contactType": "${schemaOrgMarkup.contactPoint[0].contactType}",
              "areaServed": "${schemaOrgMarkup.contactPoint[0].areaServed}",
              "availableLanguage": "${schemaOrgMarkup.contactPoint[0].availableLanguage}"
              },
              {
              "@type": "${schemaOrgMarkup.contactPoint[1]._type}",
              "telephone": "${schemaOrgMarkup.contactPoint[1].telephone}",
              "contactType": "${schemaOrgMarkup.contactPoint[1].contactType}",
              "areaServed": "${schemaOrgMarkup.contactPoint[1].areaServed}",
              "availableLanguage": "${schemaOrgMarkup.contactPoint[1].availableLanguage}"
              }
            ] 
          }`}
        </script>
      ))
    : schemaOrgMarkup?._type === "FAQPage" &&
        schemaOrgMarkup !== null &&
        schemaOrgMarkup !== undefined
      ? (schemaOrgJson = (
          <script type="application/ld+json">
            {`{
          "@context": "${schemaOrgMarkup._context}",
          "@type": "${schemaOrgMarkup._type}",
          "mainEntity": [${schemaOrgMarkup.mainEntity
            .filter(item => item)
            .map(
              (item, index, array) => `
                {
                  "@type": "${item._type}",
                  "name": "${item.name}",
                  "acceptedAnswer": {
                    "@type": "${item.acceptedAnswer._type}",
                    "text": "${item.acceptedAnswer.text}"
                  }
                }${index < array.length - 1 ? "," : ""}
              `,
            )
            .join("")}]
        }`}
          </script>
        ))
      : (schemaOrgJson = null)
  if (props.schemaOrgText) {
    schemaOrgText = [
      {
        type: "application/ld+json",
        innerHTML: props.schemaOrgText,
      },
    ]
  } else {
    schemaOrgText = null
  }

  const meta: MetaDirectivesProps = props.metaData
  const metaDescription: string = props.description
  const metaTitle: string = props.title
  const metaLang: string = props.nodeLocale
  const metaRobots = meta?.robots?.map((item, index) => (
    <meta name="robots" content={item} key={index} />
  ))

  let canonicalMaker = () => {}

  const location = useLocation()

  canonicalMaker = () => {
    let canonicalList = []
    let locales = ["nl-NL", "en-GB", "de-DE", "en-US"]
    canonicalList.push({
      rel: `canonical`,
      href: process.env.TARGET_SITE + location.pathname,
    })
    for (let i = 0; i < 4; i++) {
      const canonicalElement = props.canonical[i]
      let localeUrl = ""
      if (locales[i] === "nl-NL") {
        localeUrl = ".nl/"
      } else if (locales[i] === "en-GB") {
        localeUrl = ".co.uk/"
      } else if (locales[i] === "de-DE") {
        localeUrl = ".de/"
      } else {
        localeUrl = ".com/"
      }

      if (canonicalElement !== null && canonicalElement !== undefined) {
        canonicalList.push({
          rel: `alternate`,
          hreflang: locales[i],
          href:
            process.env.TARGET_SITE.split(".")[0] +
            localeUrl +
            canonicalElement,
        })
      }
      if (process.env.TARGET_SITE === "https://edcontrols.com/") {
        canonicalList.push({
          rel: `alternate`,
          hreflang: "x-default",
          href: process.env.TARGET_SITE.split(".")[0] + localeUrl,
        })
      }

      // else {
      //   canonicalList.push({
      //     rel: `alternate`,
      //     hreflang: "x-default",
      //     href:
      //     process.env.TARGET_SITE.split('.')[0] +
      //     localeUrl
      //   })
      // }
    }
    return canonicalList
  }

  const generateTwitterTags = () => {
    if (meta?.twittertitle) {
      return (
        <>
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content={meta?.twittertitle} />
          <meta
            name="twitter:description"
            content={meta?.twitterTwitterdescription}
          />
          <meta name="twitter:url" content="" />
          <meta
            name="twitter:image"
            content={meta?.twitterTwitterimage?.file.url}
          />
        </>
      )
    }

    return (
      // <Helmet
      //   htmlAttributes={{ lang: meta.node_locale }}
      //   script={schemaOrgText}
      // >
      <div itemscope itemtype="http://schema.org/WebPage">
        <title itemProp="name" lang={meta.node_locale}>
          {metaTitle}
        </title>

        <meta name="description" content={metaDescription} />
        <meta
          name="google-site-verification"
          content="f0vL8TxTPKVBjFgPjB8_Wy3O7P0ypx6z4oIYQSDGcl"
        />

        <link
          href="https://assets.calendly.com/assets/external/widget.css"
          rel="stylesheet"
        />
        <Script
          src="https://assets.calendly.com/assets/external/forms.js"
          type="text/javascript"
          strategy={ScriptStrategy.postHydrate}
          async
        ></Script>
        {metaRobots}
        {schemaOrgJson}

        {schemaOrgText}
        {canonicalMaker().map((item, index) => (
          <link
            rel={item.rel}
            href={item.href}
            hrefLang={item.hreflang}
            key={index}
          />
        ))}

        {generateTwitterTags}
        {/* </Helmet> */}
      </div>
    )
    return null
  }

  return (
    <React.Fragment>
      {/* <Helmet
        htmlAttributes={{ lang: meta?.node_locale }}
        script={schemaOrgText}
      > */}
      <div itemscope itemtype="http://schema.org/WebPage">
        <html lang={meta?.node_locale} />
        <title itemProp="name" lang={meta?.node_locale}>
          {metaTitle}
        </title>

        <meta
          name="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta name="Pragma" content="no-cache" />
        <meta name="Expires" content="0" />

        <meta name="description" content={metaDescription} />
        <meta
          name="google-site-verification"
          content="f0vL8TxTPKVBjFgPjB8_Wy3O7P0ypx6z4oIYQSDGcl"
        />

        {metaRobots}
        {schemaOrgJson}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={process.env.TARGET_SITE + location.pathname}
        />
        {meta?.ogImage !== null || undefined ? (
          <meta
            property="og:image"
            content={"https:" + meta?.ogImage?.file?.url}
          />
        ) : (
          <meta property="og:image" />
        )}
        {<meta property="og:title" content={metaTitle} />}
        {<meta property="og:description" content={metaDescription} />}
        {generateTwitterTags}
        {schemaOrgText && (
          <script
            type={schemaOrgText[0].type}
            dangerouslySetInnerHTML={{ __html: schemaOrgText[0].innerHTML }}
          />
        )}
        {canonicalMaker().map((item, index) => (
          <link
            rel={item.rel}
            href={item.href}
            hrefLang={item.hreflang}
            key={index}
          />
        ))}

        {schemaOrg}

        {/* </Helmet> */}
      </div>
    </React.Fragment>
  )
  return null
}
